// extracted by mini-css-extract-plugin
export default {"content":"Simple_content__f6P1s","languageSwitcher":"Simple_languageSwitcher__wN5HK"};